module.exports = __webpack_public_path__ + "static/img/fail_work.8400775.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/fail_work.svg
// module id = aZFQ
// module chunks = 1